import React, { useCallback } from 'react';
import { MenuButton, MenuList } from '@ls/react-menu';
import styles from './KebabMenu.module.css';
import Icon from 'react-icons-kit';
import { ic_more_vert } from 'react-icons-kit/md/ic_more_vert';
import Input from '@ls/react-input';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAppDecimal,
  selectAppTitle,
  selectBandedRows,
  selectDisplayMajorsAndMinorsOnTitle,
  selectGridFontSize,
  selectGridRowHeight,
  selectGridVerticalLines,
  selectHideGridSideBar,
  selectNoAccountFlag
} from 'state/app/selectors';
import {
  setAppDecimal,
  setAppTitle,
  setBandedRows,
  setGridFontSize,
  setGridRowHeight,
  setGridVerticalLines,
  setHideGridSideBar,
  setNoAccountFlag,
  setDisplayMajorMinorOnTitle
} from 'state/app/actions';
import Checkbox from '@ls/react-checkbox';

export default props => {
  const dispatch = useDispatch();
  const appTitle = useSelector(selectAppTitle);
  const appDecimal = useSelector(selectAppDecimal);
  const bandedRows = useSelector(selectBandedRows);
  const gridVerticalLines = useSelector(selectGridVerticalLines);
  const gridFontSize = useSelector(selectGridFontSize);
  const gridRowHeight = useSelector(selectGridRowHeight);
  const hideGridSideBar = useSelector(selectHideGridSideBar);
  const noAccountSelectedFlag = useSelector(selectNoAccountFlag);
  const displayMajorMinorOnTitle = useSelector(selectDisplayMajorsAndMinorsOnTitle);

  const onDecimalChange = useCallback(
    val => {
      dispatch(setAppDecimal(Number(val)));
    },
    [dispatch]
  );

  const onAppTitleChange = useCallback(
    val => {
      dispatch(setAppTitle(val));
    },
    [dispatch]
  );

  const onBandedRowsChange = useCallback(() => {
    dispatch(setBandedRows(!bandedRows));
  }, [bandedRows, dispatch]);

  const onGridVerticalLinesChange = useCallback(() => {
    dispatch(setGridVerticalLines(!gridVerticalLines));
  }, [gridVerticalLines, dispatch]);



  const onGridFontSizeChange = useCallback(
    val => {
      dispatch(setGridFontSize(Number(val)));
    },
    [dispatch]
  );

  const onNoAccountSelectedFlagChange = useCallback(
    (value) => {
      dispatch(setNoAccountFlag(value));
    },
    [dispatch]
  );

  const onGridRowHeightChange = useCallback(
    val => {
      dispatch(setGridRowHeight(Number(val)));
    },
    [dispatch]
  );
  const onChangeHideSideBar = useCallback((val) => {
    dispatch(setHideGridSideBar(!val));
  }, [dispatch]);
  
  const onDisplayMajorMinorOnTitleChange = useCallback(() => {
    dispatch(setDisplayMajorMinorOnTitle(!displayMajorMinorOnTitle));
  }, [displayMajorMinorOnTitle, dispatch]);

  const hideGridBarOption = new URLSearchParams(window.location.search)?.get('hideGridBarOption');

  return (
    <MenuButton
      buttonVariation={5}
      menuList={
        <MenuList>
          <div className={styles.item}>
            <Checkbox
              label={'Display Majors & Minors on Title'}
              value={displayMajorMinorOnTitle}
              onChange={onDisplayMajorMinorOnTitleChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={'Grid Banded Rows'}
              value={bandedRows}
              onChange={onBandedRowsChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={'Grid Vertical Lines'}
              value={gridVerticalLines}
              onChange={onGridVerticalLinesChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={'Load up with No Account'}
              value={noAccountSelectedFlag}
              onChange={onNoAccountSelectedFlagChange}
            />
          </div>

          {
            hideGridBarOption !== 'true' &&
            (<div className={styles.item}>
              <Checkbox
                label={"Show Grid Side Bar"}
                value={!hideGridSideBar}
                onChange={onChangeHideSideBar}
              />
            </div>)
          }

          <div className={styles.item}>
            <Input
              label={'Grid font size:'}
              value={gridFontSize}
              onChange={onGridFontSizeChange}
              min={8}
              max={16}
              type={'number'}
              size={'S'}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={'Grid row height:'}
              value={gridRowHeight}
              onChange={onGridRowHeightChange}
              min={10}
              max={40}
              type={'number'}
              size={'S'}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={'Default decimals:'}
              value={appDecimal}
              onChange={onDecimalChange}
              min={0}
              max={8}
              type={'number'}
              size={'S'}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={'Title:'}
              value={appTitle}
              onChange={onAppTitleChange}
              size={'S'}
            />
          </div>
        </MenuList>
      }
      icon={<Icon icon={ic_more_vert} size={30} />}
      tooltip="Settings"
    />
  );
};
